module.exports = __webpack_public_path__ + "static/media/All companies.6bbbcd60.svg";